import { findAll } from './findAll';

export const genreAPI = {
  findAll,
};
